import { styled } from '@mui/material';

import { useMemo } from 'react';

import { TTeamMemberDto } from '@app-velocity/av-api-v2';
import { useI18n } from '@app-velocity/i18n';

export type RoleProps = {
  role: TTeamMemberDto['teamRole'];
};

const StyledRole = styled('span')({
  fontWeight: 600,
});

export const Role = ({ role }: RoleProps) => {
  const { t } = useI18n();

  const roleLabel = useMemo(() => {
    switch (role) {
      case 'ADMIN': {
        return t('teams:role.admin');
      }

      case 'OWNER': {
        return t('teams:role.owner');
      }

      case 'MEMBER': {
        return t('teams:role.member');
      }

      default:
        return '-';
    }
  }, [role, t]);

  return <StyledRole>{roleLabel}</StyledRole>;
};
